import SDemo from "./SDemo_web"
export default SDemo
